import { Directive } from '@angular/core';
@Directive({ selector: 'time'})
export class TimeDirective {}



// WEBPACK FOOTER //
// ./src/app/shared/utils/time.directive.ts